import * as XLSX from 'xlsx'
import { Bell, ChevronDown, ChevronUp, Cloud, Download, Import, Plus, Sort } from 'assets'
import CustomButton from 'components/CustomButton'
import { FormInputs, FormSelects } from 'components/FormInputSelect'
import { TOOLBAR_SELECT_STYLES } from "components/toolbarSelectStyles";
import React, { useEffect, useState } from 'react'
import { BiFilter } from 'react-icons/bi'
import { Button, Container, Spinner } from 'reactstrap'
import './katalogLagu.scss'
import data from 'pages/dashboard/dashboardDummy'
import Table from 'components/Table'
import StatusBadge from 'components/StatusBadge'
import { columnLayout } from 'components/tableColumnLayout'
import { FiSearch } from 'react-icons/fi'
import AddLagu from './AddLagu'
import { API_DELETE_MAMBOO, API_GET_MAMBOO, API_POST_MAMBOO } from 'services'
import Detail from './Detail'
import Pagination from 'components/Pagination'
import ModalImport from 'components/ModalImport'
import { Alert, validateAlert } from 'components/Alert'
import Swal from 'sweetalert2'
import { getCookie } from 'services/cookies'
import { useLocation, useNavigate } from 'react-router-dom'
import TableLoading from 'components/TableLoading'
import useLoginStore from 'hooks/useLoginStore'

// Tabel memakai `id` sebagai keyField, jadi diisi song_id. Kolom `id` asli lagu
// (kode yang ditampilkan sebagai Work ID) disimpan lebih dulu ke `work_id`,
// kalau tidak nilainya hilang tertimpa.
const toTableRows = (rows) =>
  rows.map((row) => ({ ...row, work_id: row.id, id: row.song_id }))

const KatalogLagu = () => {

  const [limit, setLimit] = useState(5)
  const [fileValue, setFileValue] = useState('')
  const [search, setSearch] = useState({ label: 'Cari Judul Lagu', value: 'judul' })
  const [searchValue, setSearchValue] = useState('')
  const [page, setPage] = useState(1)
  const [dragActive, setDragActive] = useState(false)
  const [totalPage, setTotalPage] = useState()
  const title = ['Songwriter Lainnya', 'Penyanyi', 'Tipe Lisensi', 'Periode Pemakaian', 'Harga Semua Project']
  const [addLagu, setAddLagu] = useState("")
  const location = useLocation()

  // Form tambah/edit lagu dirender di path yang sama dengan daftar, jadi klik
  // "List Lagu" di sidebar tidak me-remount halaman ini dan form tetap terbuka.
  // location.key selalu baru di setiap navigate, jadi dipakai sebagai sinyal
  // untuk kembali ke tampilan daftar.
  useEffect(() => {
    setAddLagu("")
  }, [location.key])
  const [dataDetail, setDataDetail] = useState({})
  const [rowData, setRowData] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingModal, setIsLoadingModal] = useState(false)
  const [songList, setSongList] = useState([])
  const [readOnly, setReadOnly] = useState(false)
  const navigate = useNavigate()
  const { profile, isVerified } = useLoginStore();

  const [modal, setModal] = useState(false);
  const [previewData, setPreviewData] = useState({ headers: [], rows: [] });

  const toggle = async () => {
    if(!modal) {
      
      let active = []
      let inactive = []

      await API_GET_MAMBOO.dynamic
        .getListPencipta(1, 5, "active", '')
        .then((resp) => {
          active = resp.data
        });
      await API_GET_MAMBOO.dynamic
        .getListPencipta(1, 5, "inactive", '')
        .then((resp) => {
          inactive = resp.data
        });


      if([...active, ...inactive].length > 0) {
        setModal(!modal)
      } else {
        validateAlert({
          icon: 'warning',
          title: 'Data Anggota Tidak ada',
          text: 'Harap buat data anggota terlebih dahulu, setelahnya anda bisa membuat lagu.',
          confirmButtonText: 'Menuju Halaman Anggota',
          confirmed: () => navigate("/pencipta")
        })
        
      }
    } else {
      setModal(!modal)
    }
    setFileValue('')
    setPreviewData({ headers: [], rows: [] })
  };


    const customStyleSearch = {
    control: (provided, state) => ({
      ...provided,
      padding: '0px',
      border: 'none',
      outline: 'none'
    }),

    valueContainer: (provided, state) => ({
      ...provided,
    }),

    singleValue: (provided, state) => ({
      ...provided,
      textAlign: 'center'
    }),

    input: (provided, state) => ({
      ...provided,
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
    }),
  };

  // StatusBadge bawaannya `flex: 1 0 0`, sehingga melar selebar selnya —
  // kotaknya jadi jauh lebih lebar daripada teksnya. Di sini dibuat sepanjang
  // isinya saja.
  const BADGE_FIT = { flex: '0 0 auto', alignSelf: 'auto', width: 'fit-content' }

  const badgeFormatter = (cell) => {
    switch (cell) {
      case 'Dalam Pemakaian':
        return <StatusBadge customStyle={{ ...BADGE_FIT, color: "#BF6919", border: "1px solid var(--warning-border)", background: 'var(--surface-2)' }} title={cell} />
      case 'Tersedia':
        return <StatusBadge customStyle={{ ...BADGE_FIT, color: "#367A59", border: "1px solid var(--success-border)", background: 'var(--surface-2)' }} title={cell} />
      case 'Tidak Tersedia':
        return <StatusBadge customStyle={{ ...BADGE_FIT, color: 'var(--text-muted)', border: '1px solid var(--border)', background: 'var(--surface-2)' }} title={cell} />
    }
  }

  const dateFormatter = (cell) => {
    return cell.split('T')[0]
  }

  const columnRefs = [
    {
      dataField: 'song_title',
      text: <><span>Judul Lagu</span><Sort /></>,
      sort: true,
      headerStyle: columnLayout(1.8),
      style: columnLayout(1.8)
    }, {
      dataField: 'creator_name',
      text: <><span>Songwriter</span></>,
      headerStyle: columnLayout(1.8),
      style: columnLayout(1.8)
    }, {
      dataField: 'genre',
      text: 'Genre',
      headerStyle: columnLayout(1.2),
      style: columnLayout(1.2)
    },
    // {
    //   dataField: 'created_at',
    //   text: <><span>Tanggal</span><Sort /></>,
    //   sort: true,
    //   formatter: (cell, row) => dateFormatter(cell)
    // }, 
    {
      dataField: 'status',
      text: 'Status',
      formatter: (cell, row) => badgeFormatter(cell),
      headerStyle: columnLayout(1.4, 'center'),
      style: columnLayout(1.4, 'center')
    }
  ]

  const options = [
    {
      label: '5',
      value: 5
    },
    {
      label: '10',
      value: 10
    },
    {
      label: '25',
      value: 25
    },
    {
      label: '50',
      value: 50
    }
  ]

  const searchOptions = [
    {
      label: 'Cari Judul Lagu',
      value: 'judul'
    },
    {
      label: 'Cari Genre Lagu',
      value: 'genre'
    },
    {
      label: 'Cari Songwriter',
      value: 'pencipta'
    },
    {
      label: 'Cari Status Lagu',
      value: 'status'
    }
  ]



  const deleteLagu = async (id) => {
    await API_DELETE_MAMBOO.dynamic.deleteSong(id)
      .then((res) => {
        fetchSong(page, limit)
      })
      .catch((err) => console.log(err))
  }

  const handleDeleteLagu = (id, judul) => {
    Alert({
      icon: 'warning',
      title: 'Hapus Lagu',
      text: `Hapus lagu '${judul}'`,
      showCancelButton: true,
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Batal',
      confirmButtonColor: 'var(--danger)',
      successText: `Lagu '${judul}' berhasil dihapus`,
      failText: `Lagu '${judul} gagal dihapus`,
      cancelText: `Lagu '${judul}' batal dihapus`,
      confirmed: () => deleteLagu(id)
    })
  }

  const expandComponent = {
    renderer: (row) => (
      <div className="expand-container">
        {row.expand &&
          Object.keys(row.expand).map((item, i) => (
            <div className="expand-content">
              <span
                className="expand-title"
                style={{ textTransform: "capitalize", fontSize: "16px" }}
              >
                {title[i]}
              </span>
              <div className="expand-data">
                {item !== "total_price" ? (
                  row.expand[item].map((val, i) => (
                    <span className="expand-text">{val}</span>
                  ))
                ) : (
                  <span className="expand-text">{row.expand[item]}</span>
                )}
                {i === Object.keys(row.expand).length - 1 && (
                  <div className="d-flex flex-column">
                    <CustomButton
                      label="Detail Lagu"
                      size="btn-sm"
                      className="btn-full button-import mt-5 align-self-center ms-4"
                      onClick={(e) =>
                        handleOnClick("editLagu", row.song_id, row)
                      }
                    />
                    {getCookie("publisher") == 3 || readOnly ? null : (
                      <CustomButton
                        label="Hapus Lagu"
                        size="btn-sm"
                        className="btn-full button-delete mt-2 align-self-center ms-4"
                        onClick={(e) =>
                          handleDeleteLagu(row.song_id, row.song_title)
                        }
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    ),
    onlyOneExpanding: true,
    parentClassName: (isExpanded, row, rowIndex) => {
      return "parent-expand";
    },
    className: (isExpanded, row, rowIndex) => {
      return "row-expand";
    },
    expandByColumnOnly: true,
    showExpandColumn: true,
    expandColumnPosition: "right",
    expandHeaderColumnRenderer: () => "Detail",
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <ChevronUp />;
      } else {
        return <ChevronDown />;
      }
    },
  };

  const onChangeSelect = (e, name) => {
    setSearchValue('')
    switch (name) {
      case 'limit':
        setLimit(e.value)
        break;
      case 'search':
        setSearch(e)
        break;
      default:
        break;
    }
  }

  const onChangeSearch = (e) => {
    const { value } = e.target
    setSearchValue(value)
  }

  const onClickSearch = () => {
    // console.log(searchValue, search.value)
    fetchSong(page, limit, searchValue)
  }

  const onChangeFile = (e) => {
    const { files } = e.target
    if (files[0]) {
      const file = files[0]
      const fileUrl = URL.createObjectURL(file)
      setFileValue({ name: file.name, data: fileUrl, files: file })

      const reader = new FileReader()
      reader.onload = (evt) => {
        const wb = XLSX.read(new Uint8Array(evt.target.result), { type: 'array' })
        const ws = wb.Sheets[wb.SheetNames[0]]
        const jsonData = XLSX.utils.sheet_to_json(ws, { header: 1 })
        if (jsonData.length > 0) {
          setPreviewData({ headers: jsonData[0], rows: jsonData.slice(1, 6) })
        }
      }
      reader.readAsArrayBuffer(file)
    }
  }
  const handleOnClick = async (e, id, row) => {
    setRowData(row)
    if (e === 'editLagu') {
      await API_GET_MAMBOO.dynamic.getSongDetail(id)
        .then((response) => {
          response.lisence = response.lisence.sort((a, b) => Number(a.creator_code) - Number(b.creator_code))
          setDataDetail(response)
        })
      // setDataDetail(detail[0].detailData)

    }

    if(e === 'tambahLagu') {

      let active = []
      let inactive = []

      await API_GET_MAMBOO.dynamic
        .getListPencipta(1, 5, "active", '')
        .then((resp) => {
          active = resp.data
        });
      await API_GET_MAMBOO.dynamic
        .getListPencipta(1, 5, "inactive", '')
        .then((resp) => {
          inactive = resp.data
        });


      if([...active, ...inactive].length > 0) {
        return setAddLagu(e)
      } else {
        return validateAlert({
          icon: 'warning',
          title: 'Data Anggota Tidak ada',
          text: 'Harap buat data anggota terlebih dahulu, setelahnya anda bisa membuat lagu.',
          confirmButtonText: 'Menuju Halaman Anggota',
          confirmed: () => navigate("/pencipta")
        })
        
      }
    }
    setAddLagu(e)

  }

  const fetchSong = async (page, limit, keyword) => {
    setIsLoading(true)
    await API_GET_MAMBOO.dynamic.getSongList(page, limit, keyword)
      .then((response) => {
        let totalPage = Math.ceil(response.total / limit)
        setTotalPage(totalPage)
        setSongList(toTableRows(response.data))
        setIsLoading(false)
      })
  }

  const handleClickNumber = async (page) => {
    // Keyword ikut dikirim supaya hasil pencarian tidak hilang saat pindah halaman.
    await API_GET_MAMBOO.dynamic.getSongList(page, limit, searchValue).then((response) => {
      let totalPage = Math.ceil(response.total / limit)
      setSongList(toTableRows(response.data))
      setTotalPage(totalPage)
      setPage(page)
    })
  }

  const handleDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const data = {
        target: {
          files: e.dataTransfer.files
        }
      }
      onChangeFile(data)
    }
  }

  const handleOnClickExcel = async () => {
    setIsLoadingModal(true);
    const formData = new FormData();

    if (fileValue.files) {
      formData.append('excel_file', fileValue.files)
      await API_POST_MAMBOO.actions.postBulkSong(formData).then((response) => {
        setIsLoadingModal(false)
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Data berhasil di upload",
          showConfirmButton: false,
          timer: 1500
        });
        setFileValue('')
        setModal(!modal)
        window.location.reload()
      }).catch((err) => {
        setIsLoadingModal(false)
        Swal.fire({
          position: "center",
          icon: "error",
          title: err.response.data.data|| "Data gagal di upload",
          showConfirmButton: true,
          timer: 1500
        });
      })
    }
  }

  const modalContent = () => {
    if (previewData.headers.length > 0) {
      return (
        <div className='custom-modal-body'>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ background: 'var(--brand)', color: 'var(--brand-contrast)', borderRadius: '50%', width: '22px', height: '22px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold' }}>2</span>
              <span style={{ fontWeight: '600', fontSize: '14px' }}>Preview Data</span>
            </div>
            <button
              onClick={() => { setPreviewData({ headers: [], rows: [] }); setFileValue('') }}
              style={{ fontSize: '12px', color: 'var(--brand)', background: 'none', border: '1px solid var(--brand)', borderRadius: '4px', padding: '2px 10px', cursor: 'pointer' }}
            >
              Ganti File
            </button>
          </div>
          <span style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'block', marginBottom: '10px' }}>
            File: <strong>{fileValue.name}</strong>
          </span>
          <div style={{ overflowX: 'auto', border: '1px solid var(--border)', borderRadius: '6px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
              <thead>
                <tr style={{ background: 'var(--brand)' }}>
                  {previewData.headers.map((h, i) => (
                    <th key={i} style={{ padding: '8px 12px', color: 'var(--brand-contrast)', textAlign: 'left', whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {previewData.rows.map((row, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : 'var(--surface-2)' }}>
                    {previewData.headers.map((_, j) => (
                      <td key={j} style={{ padding: '7px 12px', borderTop: '1px solid var(--border)', whiteSpace: 'nowrap' }}>{row[j] ?? ''}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <span style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '6px', display: 'block' }}>
            Menampilkan {previewData.rows.length} baris pertama
          </span>
        </div>
      )
    }

    return (
      <div className='custom-modal-body'>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
          <span style={{ background: 'var(--brand)', color: 'var(--brand-contrast)', borderRadius: '50%', width: '22px', height: '22px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold' }}>1</span>
          <span style={{ fontWeight: '600', fontSize: '14px' }}>Upload File</span>
        </div>
        <div className='download-template' onClick={() => window.open('https://app.mamboomusic.com/template/template_lagu.xlsx')}>
          <span>Download Template Katalog Lagu</span>
          <Download stroke="#3267E3" />
        </div>
        <div className='upload-container' onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}>
          <div className='upload-content'>
            <Cloud />
            <span className='file-name' style={{ color: 'var(--text-primary)', fontSize: '16px' }}>
              {fileValue.name || 'Upload katalog lagu dari komputer atau drop file langsung disini'}
            </span>
            <div>
              <input onChange={onChangeFile} id="upload-file" className='custom-file-input' type='file' accept='.xlsx,.xls' />
              <label htmlFor='upload-file' className='custom-file-upload'><Plus stroke='#FFFFFF' /></label>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const modalContentVerified = () => {
    return (
      <div className="custom-modal-body">
        <span style={{fontSize: 'large', fontWeight: 'bold', textAlign: 'center'}}>Segera Verifikasi Publisher</span>
          <span style={{fontSize: 'small', fontSize: '15px'}}>Buka semua fitur yang ada dengan cara melengkapi dokumen yang ada dan nantinya akan kami verifikasi terlebih dahulu.</span>
      </div>
    )
  }

  useEffect(() => {
    fetchSong(page, limit)

    if(profile.access && profile?.access?.length > 0) {
      profile.access.filter((val) => {
        if(val.access_name === "Katalog Lagu") {
          setReadOnly(val.is_read_only)
        } else if (val.access_name === "Super Admin") {
          setReadOnly(val.is_read_only)
        }
      })
    }

  }, [limit, addLagu])

  if (addLagu === 'tambahLagu') return <AddLagu handleOnClick={handleOnClick} />
  if (addLagu === 'editLagu') return <Detail handleOnClick={handleOnClick} data={dataDetail} rowData={rowData} />

  return (
    <>
      <ModalImport
        modal={modal}
        toggle={toggle}
        title="Upload Katalog Lagu"
        body={modalContent()}
        buttonLabel={
          isLoadingModal ? (
            <>
              <Spinner size="sm" color="light" />
              &nbsp;&nbsp;Upload File
            </>
          ) : (
            "Upload File"
          )
        }
        onClick={handleOnClickExcel}
      />
      <Container fluid className="katalog-lagu-container">
        <div className="header-content">
          <div className="katalog-header">
            <h1>Katalog Lagu</h1>
            <span>List lagu yang terdaftar</span>
          </div>
          <div className="icon-wrapper">
            <Bell />
          </div>
        </div>
        <div className="tabs-filters">
          <div className="frame-filters">
            <div
              className="frame-sub-filters"
              style={{ overflow: "unset", padding: "1px" }}
            >
              <div className="frame-cari-nama">
                <div className="w-100">
                  <FormSelects
                    options={searchOptions}
                    onChange={(e) => onChangeSelect(e, "search")}
                    defaultValue={search.value}
                    value={search.value}
                    styles={customStyleSearch}
                  />
                </div>
                <FormInputs
                  onChange={onChangeSearch}
                  value={searchValue}
                  placeholder={"Masukan " + search.label.split("Cari ")[1]}
                  className="frame-cari-nama"
                />
                <div
                  className="frame-search"
                  style={{ cursor: "pointer" }}
                  onClick={() => onClickSearch()}
                >
                  <FiSearch />
                </div>
              </div>
            </div>
            <CustomButton
              label="Filter"
              LabelIcon={BiFilter}
              iconPosition="left"
              size="md"
              className="button-filter"
            />
            {getCookie("publisher") == 3 || readOnly ? null : (
              <CustomButton
                label="Import"
                LabelIcon={Import}
                onClick={toggle}
                iconPosition="left"
                size="md"
                className="button-import"
              />
            )}
            {getCookie("publisher") == 3 || readOnly ? null : (
              <CustomButton
                label="+ Create"
                color="primary-btn"
                size="md"
                className="button-add-anggota"
                onClick={(e) => handleOnClick("tambahLagu")}
              />
            )}
          </div>
        </div>
        {isLoading ? (
          <div className="">
            {/* <Spinner size="lg" color="light" /> */}
            <TableLoading columnRefs={columnRefs} isShow={limit} />
          </div>
        ) : (
          <Table
            columnRefs={columnRefs}
            dataTable={songList}
            expandRow={expandComponent}
            noDataText="Tidak Ada Data Lagu"
          />
        )}
        {/* Satu baris kaki tabel: pemilih jumlah baris di kiri, lalu
            keterangan halaman dan navigasinya. Ketiganya mengatur paginasi,
            jadi dikumpulkan dalam satu baris. Garis atas dan padding kiri
            dipindah ke pembungkus ini (lihat .table-footer di pencipta.scss)
            supaya garisnya membentang penuh, bukan mulai setelah "Show". */}
        <div className="table-footer">
          <div className="table-footer-filters">
            <p className="text-show">Show :</p>
            <FormSelects
              options={options}
              onChange={(e) => onChangeSelect(e, "limit")}
              defaultValue={limit}
              value={limit}
              styles={TOOLBAR_SELECT_STYLES}
            />
          </div>
          <Pagination
            isTotalPage={totalPage}
            isPage={page}
            handleClickNumber={handleClickNumber}
            pageToShow={6}
          />
        </div>
      </Container>
      <ModalImport
        modal={!isVerified}
        title=""
        body={modalContentVerified()}
        centered={true}
        buttonLabel={"Go to Profile"}
        onClick={() => navigate("/profile")}
      />
    </>
  );
}

export default KatalogLagu